const enabled =
  process.env.NODE_ENV === 'development' ||
  process.env.NODE_ENV === 'test' ||
  (typeof window !== 'undefined' && window.PUPPETEER_TEST_RUN === true);

export const generateDataTestidAttribute = (testid) => {
  const props = {};

  if (enabled && testid !== undefined && testid !== '') {
    props['data-testid'] = testid;
  }

  return props;
};

const sanitizeTestid = (testid) => (testid === undefined ? '' : testid.replace(/[\s-]+/g, '-').toLowerCase());

// Aliases for migration (various naming conventions used across codebase)
export const testId = generateDataTestidAttribute;
export { sanitizeTestid };
